var _rect, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 49V53.5C66 59.0228 61.5228 63.5 56 63.5H52.5M52.5 63.5L56 60M52.5 63.5L56 67M31 46.5V42C31 36.4772 35.4772 32 41 32H44.5M44.5 32L41 35.5M44.5 32L41 28.5M38 65.5H45C47.2091 65.5 49 63.7091 49 61.5V54C49 51.7909 47.2091 50 45 50H31.5C29.2909 50 27.5 51.7909 27.5 54V61.5C27.5 63.7091 29.2909 65.5 31.5 65.5H32.5V70.5L38 65.5ZM59 41H52C49.7909 41 48 39.2091 48 37V29.5C48 27.2909 49.7909 25.5 52 25.5H65.5C67.7091 25.5 69.5 27.2909 69.5 29.5V37C69.5 39.2091 67.7091 41 65.5 41H64.5V46L59 41Z",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 33.5,
    r: 1.5,
    fill: "#008CB7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 58.5,
    r: 1.5,
    fill: "#008CB7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 33.5,
    r: 1.5,
    fill: "#008CB7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 58.5,
    r: 1.5,
    fill: "#008CB7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 33.5,
    r: 1.5,
    fill: "#008CB7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 58.5,
    r: 1.5,
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsg8);
export default __webpack_public_path__ + "static/media/esg8.60abe7b18da7fdce4a39d84e76584343.svg";
export { ForwardRef as ReactComponent };